// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1icn9","infoBtn":"quickbooks_infoBtn__3A_lB","formBox":"quickbooks_formBox__3hJtR","formFooter":"quickbooks_formFooter__2KZtQ"};